export const ManagementNoteListCardSkeleton = () => (
  <div className='w-full'>
    <div className='relative pt-5 sm:pt-3.5 px-4 p-3.5 bg-surface rounded-[30px] text-[0.8em] leading-[1.4em] sm:text-[0.95em] jost-light flex flex-col gap-[10px] w-full animate-pulse'>
      <div className='flex flex-col w-full gap-[5px]'>
        <div className='grow w-full flex items-start justify-between gap-[10px] sm:gap-[5px]'>
          <div className='grow relative overflow-hidden flex flex-col items-between justify-center gap-[5px] text-left bg-surface-2 p-[15px] pt-[25px] rounded-[20px] min-h-[60px] sm:min-h-[70px]'>
            <div className='absolute top-[0px] right-[0px] px-[15px] text-[0.8rem] bg-surface rounded-bl-[15px] inline-block ml-auto' />
            <div className='py-[10px]' />
          </div>
        </div>
      </div>
    </div>
  </div>
)
